import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useQueryValues(
  dateRangeKeys?: Record<string, string[]>,
) {
  const [searchParams] = useSearchParams();

  const defaultValues = useMemo(() => {
    const targetValues = Object.fromEntries(searchParams);

    return Object.entries(targetValues).reduce((acc, cur) => {
      const [key, value] = cur;

      if (dateRangeKeys && dateRangeKeys[key]) {
        const [startText, endText] = dateRangeKeys[key];
        const [start, end] = value.split(',');

        return {
          ...acc,
          [startText]: start || undefined,
          [endText]: end || undefined,
        };
      }

      return { ...acc, [key]: value };
    }, {});
  }, [dateRangeKeys, searchParams]);

  return { defaultValues };
}
